import React from "react";

import { Group, Select } from "@mantine/core";

import { useSearchRouteInfo } from "hooks/routing";
import {
  ExplorerSortKey,
  ExplorerSortDir,
  DEFAULT_SORT_DIR,
  DEFAULT_SORT_KEY,
} from "lib/frontend/benchmarking/types";
import { useIsSmallerThan } from "ui/theme/helpers";

import { SelectDropdownLabelSection } from "./SelectDropdownLabelSection";

export function ExplorerSortDropdown(): JSX.Element {
  const { replaceQuery, query } = useSearchRouteInfo();

  const isSmall = useIsSmallerThan("sm");

  let descLabel = "Highest to Lowest";
  let ascLabel = "Lowest to Highest";
  if (query.sortKey === ExplorerSortKey.ALPHABETICAL) {
    // i know, its backwards, but we just wanted the default value to match with the other sort options
    ascLabel = "Z to A";
    descLabel = "A to Z";
  }

  return (
    <Group
      wrap="nowrap"
      gap={0}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        flex: 1,
      }}
    >
      <SelectDropdownLabelSection>Sort By</SelectDropdownLabelSection>
      <Select
        value={query.sortKey ?? DEFAULT_SORT_KEY}
        data={[
          { label: "Range (High)", value: ExplorerSortKey.RANGE_HIGH },
          { label: "Range (Mid)", value: ExplorerSortKey.RANGE_MID },
          { label: "Range (Low)", value: ExplorerSortKey.RANGE_LOW },
          { label: "Job Posts", value: ExplorerSortKey.NUM_POSTS },
          { label: "Alphabetical", value: ExplorerSortKey.ALPHABETICAL },
        ]}
        styles={(theme) => ({
          root: {
            position: "relative",
            ...(isSmall && {
              flexGrow: 1,
            }),
          },
          wrapper: {
            borderRadius: 0,
            "&:focus, &:focus-within": {
              "&:after": {
                content: "''",
                position: "absolute",
                top: 0,
                height: "100%",
                right: 0,
                width: "1px",
                background: theme.colors.brand[8],
              },
            },
          },
          input: {
            borderRadius: 0,
            borderRight: 0,
          },
          label: {
            display: "none",
          },
        })}
        onChange={(sortKey) => {
          replaceQuery({
            sortKey: sortKey as ExplorerSortKey,
          });
        }}
      />
      <Select
        value={query.sortDir ?? DEFAULT_SORT_DIR}
        data={[
          { label: descLabel, value: ExplorerSortDir.DESC },
          { label: ascLabel, value: ExplorerSortDir.ASC },
        ]}
        styles={(theme) => ({
          root: {
            ...(isSmall && {
              flexGrow: 1,
            }),
          },
          wrapper: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          input: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          label: {
            display: "none",
          },
        })}
        onChange={(sortDir) => {
          replaceQuery({
            sortDir: sortDir as ExplorerSortDir,
          });
        }}
      />
    </Group>
  );
}
